
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/knowledge/blog/[slug]/[page]",
      function () {
        return require("private-next-pages/knowledge/blog/[slug]/[page]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/knowledge/blog/[slug]/[page]"])
      });
    }
  